import {Component, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'dcp-icon-button-tooltip',
  styleUrl: './icon-button-tooltip.component.scss',
  templateUrl: './icon-button-tooltip.component.html',
})
export class IconButtonTooltipComponent {
  @Input() openOnClick: boolean = false;
  @Input() openOnHover: boolean = true;
  @Input() title: string = '';
  @Input() placement: string = 'Bottom';
  @Input() disabled: boolean = false;
  @Input() size: string = 'Medium';
  @Input() noPaddings: boolean = false;
  @Input() accessibleName: string = '';
  @ViewChild('UDExTooltipOpener') tooltipOpenerRef: any;
  @ViewChild('UDExTooltip') tooltipRef: any;

  openTooltip(): void {
    this.tooltipRef.nativeElement.onOpen(this.tooltipOpenerRef.nativeElement);
  }

  closeTooltip(): void {
    this.tooltipRef.nativeElement.onClose();
  }

  handleMouseOver(): void {
    if (this.openOnHover && !this.openOnClick) {
      this.openTooltip();
    }
  }

  handleMouseOut(): void {
    if (this.openOnHover && !this.openOnClick) {
      this.closeTooltip();
    }
  }

  isTooltipOpen(): boolean {
    return this.tooltipRef.nativeElement.isOpen();
  }

  handleClick(): void {
    if (this.openOnClick) {
      if (this.isTooltipOpen()) {
        this.closeTooltip();
      } else {
        this.openTooltip();
      }
    }
  }
}
